<div class="loginPopupMainDiv" mat-dialog-content>
    <div class="loginContent" [class.reLoginPopup]="this.data.isAccessTokenExpired">
        <div class="loginTitle" *ngIf="!isForgetPasswordEnabled">
            <img src='assets/images/common/AIRAQC.png' alt="AIRA Matrix" aria-label="AIRA Matrix" class="center"
                [class.initloginPopupImg]="!this.data.isAccessTokenExpired" />
        </div>
        <ng-container *ngIf="!appConfig.isGuestLoginEnabled">
            <div class="loginCreds" [ngClass]="(isChangePassword) ? 'changePasswordInputs' : ''">
                <ng-container *ngIf="!isForgetPasswordEnabled && !isChangePassword && !isResetPassword && !renewLicense && !isMFA && qrImageBase64 === ''">
                    <mat-form-field class="loginCredentialFields loginEmailId zoomLevelMatFormfield"
                        appearance="outline" [class.readOnlyInput]="data.isAccessTokenExpired">
                        <input type="email" matInput [(ngModel)]="userEmailId" (keyup.enter)="validateLogin()"
                            placeholder="Email Id" [readonly]="data.isAccessTokenExpired">
                    </mat-form-field>

                    <mat-form-field class="loginCredentialFields loginPassword zoomLevelMatFormfield"
                        appearance="outline">
                        <input [type]="hide ? 'password' : 'text'" matInput [(ngModel)]="userPassword"
                            (keyup.enter)="validateLogin()" placeholder="Password">
                        <mat-icon matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                            {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </mat-form-field>

                    <div class="invalidCreds" *ngIf="invalidUserCredentials">Please enter valid credentials</div>
                </ng-container>

                <!--MFA Authentication-->
                <ng-container *ngIf="isMFA || qrImageBase64 !== ''">
                  <div class="mfa-container">
                    <div class="register-mfa" *ngIf="!isMFA">
                      <div class="mfa-info">
                        <h3 class="mfa-info-title">Configure Authenticator app</h3>
                        <p class="mfa-info-desc">Scan the QR code using the Google Authenticator App on your Android or iOS device.</p>
                        <img [src]="qrImageSrc" alt="QR Code" class="mfa-qr-image" />
                        <p class="mfa-info-desc">Once configured, enter the 6-digit verification code generated by the Authenticator app.</p>
                      </div>
                    </div>
                    <div class="mfa-otp-inputs" (paste)="onPaste($event)">
                      <input
                        *ngFor="let item of otp; let i = index; trackBy: trackByIndex"
                        #otpInput
                        class="mfa-otp-box"
                        type="text"
                        maxlength="1"
                        inputmode="numeric"
                        [value]="item"
                        [class.filled]="item !== ''"
                        (input)="onOTPInput($event, i)"
                        (keydown)="keydownOnOTP($event, i)"
                      />
                    </div>
                  </div>
                </ng-container>

                <!-- ForgetPassword-->
                <ng-container *ngIf="isForgetPasswordEnabled">
                    <div class="forgotPasswordHeader">
                        <span>Account Recovery</span>
                        <mat-icon style="margin-left: auto; font-weight: 600;" (click)="closeForgetPassword()"
                            class="cursorPointer customMatIcon">close</mat-icon>
                    </div>
                    <div class="passwordRecText" *ngIf="!isMailsend">
                        Enter your Email ID to recieve a Verification Code
                    </div>
                    <div class="passwordRecText" *ngIf="isMailsend && !isCodeVerified">
                        Enter Verification Code
                    </div>
                    <div class="passwordRecText" *ngIf="isCodeVerified">
                        Enter New Password
                    </div>

                    <ng-container *ngIf="!isMailsend">
                        <form [formGroup]="userEmails">
                            <mat-form-field class="loginCredentialFields loginEmailId zoomLevelMatFormfield"
                                appearance="outline">
                                <input type="email" matInput [(ngModel)]="forgetPasswordObj.emailId"
                                    placeholder="Email Id" [formControl]="emailControl" formControlName="primaryEmail"
                                    [disabled]="data.isAccessTokenExpired" (input)="checkEmail()">
                            </mat-form-field>
                        </form>
                    </ng-container>

                    <ng-container *ngIf="isMailsend && !isCodeVerified">
                        <mat-form-field class="loginCredentialFields loginEmailId zoomLevelMatFormfield"
                            appearance="outline">
                            <input type="email" matInput [(ngModel)]="forgetPasswordObj.verificationCode"
                                placeholder="Enter verification code" [disabled]="data.isAccessTokenExpired">
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="isCodeVerified">
                        <mat-form-field class="loginCredentialFields loginPassword zoomLevelMatFormfield"
                            appearance="outline">
                            <input [type]="hideNewPassword ? 'password' : 'text'" matInput
                                [(ngModel)]="forgetPasswordObj.newPassword" placeholder="New password">
                            <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword"
                                [attr.aria-label]="'Hide Newpassword'" [attr.aria-pressed]="hideNewPassword">
                                {{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="loginCredentialFields loginPassword zoomLevelMatFormfield"
                            appearance="outline">
                            <input [type]="hideConfirmPassword ? 'password' : 'text'" matInput
                                [(ngModel)]="forgetPasswordObj.confirmedPassword" placeholder="Confirm password">
                            <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                                [attr.aria-label]="'Hide Confirmedpassword'" [attr.aria-pressed]="hideConfirmPassword">
                                {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                    </ng-container>
                </ng-container>

                <!--Reset Password-->
                <ng-container *ngIf="isResetPassword">
                    <div class="forgotPasswordHeader">
                        <span>Reset Password</span>
                    </div>
                    <mat-form-field class="loginCredentialFields loginEmailId zoomLevelMatFormfield"
                        appearance="outline">
                        <input type="email" matInput [(ngModel)]="resetPassword.emailId" placeholder="Email Id"
                            [disabled]="resetPassword.emailId">
                    </mat-form-field>

                    <mat-form-field class="loginCredentialFields loginPassword zoomLevelMatFormfield"
                        appearance="outline">
                        <input [type]="hideNewPassword ? 'password' : 'text'" matInput
                            [(ngModel)]="resetPassword.newPassword" placeholder="New password">
                        <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword">
                            {{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="loginCredentialFields loginPassword zoomLevelMatFormfield"
                        appearance="outline">
                        <input [type]="hideConfirmPassword ? 'password' : 'text'" matInput
                            [(ngModel)]="resetPassword.confirmedPassword" placeholder="Confirm password">
                        <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
                            {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </mat-form-field>
                </ng-container>

                <!-- renew license -->
                <ng-container *ngIf="renewLicense">
                    <mat-form-field class="loginCredentialFields loginEmailId zoomLevelMatFormfield licenseUploadField" appearance="outline">
                        <mat-label *ngIf="!selectedLicenseFileName">Upload license file</mat-label>
                        <ngx-mat-dropzone class="licenseDropzone">
                            <input type="file" fileInput [formControl]="filesCtrl" accept=".lic" />
                        </ngx-mat-dropzone>

                        <mat-chip-row class="selectedLicenseChipWrapper selectedLicenseChip"
                            *ngIf="selectedLicenseFileName" [removable]="true"
                            (removed)="clearSelectedLicenseFile()" [title]="selectedLicenseFileName">
                            {{ selectedLicenseFileName }}
                            <button type="button" matChipRemove tabindex="-1">
                                <mat-icon style="cursor: pointer;padding: 0;min-width: 1.45vw;">cancel</mat-icon>
                            </button>
                        </mat-chip-row>

                        <mat-error *ngIf="filesCtrl.touched && !selectedLicenseFileName">
                            Please select a .lic file to upload
                        </mat-error>

                        <mat-icon matSuffix style="cursor: pointer;">cloud_upload</mat-icon>
                    </mat-form-field>
                </ng-container>
            </div>

            <div class="loginAction" [ngStyle]="{'justify-content': renewLicense ? 'space-around' : 'center'}" [class.inlineBtrnGrp]="data.isAccessTokenExpired ||  isChangePassword || renewLicense"
                [ngClass]="(isChangePassword) ? 'changePasswordInputs' : ''">
                <ng-container *ngIf="!isForgetPasswordEnabled && !isResetPassword && !renewLicense">
                    <button *ngIf="data.isAccessTokenExpired" class="btnLoginCancel" mat-flat-button color="default"
                        (click)="CancelLogin()">Cancel</button>
                    <button *ngIf="isChangePassword" class="btnLoginCancel" mat-flat-button color="default"
                        (click)="CancelChangePassword()">Cancel</button>
                    <button class="btnLogin" mat-flat-button color="primary" *ngIf="!isChangePassword && !isMFA && qrImageBase64 === ''"
                        (click)="validateLogin()">Login</button>
                    <button class="btnLogin" mat-flat-button color="primary" *ngIf="isMFA || qrImageBase64 !== ''" [disabled]="!isComplete"
                        (click)="validateOtp()">Validate Login</button>
                    <button class="btnLogin" mat-flat-button color="primary" *ngIf="isChangePassword"
                        [disabled]="((!forgetPasswordObj.newPassword || !forgetPasswordObj.confirmedPassword) || invalidNewUserPassword || (forgetPasswordObj.newPassword != forgetPasswordObj.confirmedPassword) || (forgetPasswordObj.newPassword == forgetPasswordObj.oldPassword))"
                        (click)="setNewPassword()">{{data.confirmButtonText}}</button>
                </ng-container>
                <ng-container *ngIf="renewLicense">
                    <button class="btnLoginCancel" style="background-color:#a2a2a2;color:#fff" mat-flat-button color="default" (click)="cancelUpload($event)">Cancel</button>
                    <button class="btnLogin" mat-flat-button color="primary" (click)="uploadLicense()" [disabled]="isLicenseUploading">
                        {{ isLicenseUploading ? 'Uploading...' : 'Upload' }}
                    </button>

                </ng-container>

                <ng-container *ngIf="isForgetPasswordEnabled">
                    <ng-container *ngIf="!isCodeVerified">
                        <ng-container *ngIf="!isMailsend && !showLoader">
                            <button class="btnLogin" mat-flat-button color="primary" (click)="sendMail()"
                                [disabled]="!validEmail">Send Verification Code</button>
                        </ng-container>
                        <ng-container *ngIf="!isMailsend && showLoader">
                            <button class="btnLogin" mat-flat-button color="primary" [disabled]="true">Sending mail
                                ...</button>
                        </ng-container>

                        <ng-container *ngIf="isMailsend ">
                            <button class="btnLogin" mat-flat-button color="primary" (click)="verifyCode()"
                                [disabled]="!forgetPasswordObj.verificationCode">Submit
                                Verification Code</button>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngIf="isCodeVerified">
                        <button class="btnLogin" mat-flat-button color="primary"
                            (click)="setNewPassword()">Submit</button>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="isResetPassword">
                    <button class="btnLogin" mat-flat-button color="primary" (click)="newUserPasswordReset()">Reset
                        Password</button>
                </ng-container>
            </div>

            <ng-container
                *ngIf="!data.isAccessTokenExpired && !isForgetPasswordEnabled && !isChangePassword && !isResetPassword && !appConfig?.newUserPasswordRequired">
                <div class="forgetPasswordText cursorPointer" (click)="enableForgetPassword()"> Forgot password ?</div>
            </ng-container>
            <ng-container *ngIf="isResetPassword">
                <div style="color: black; padding-top: 1vh;">
                    <div>Make sure your password:</div>
                    <ul>
                        <li>Is longer than 7 characters</li>
                        <li>Includes numbers, special characters, upper case & lowercase letter</li>
                    </ul>
                </div>
            </ng-container>
        </ng-container>

        <div class="guestLogin" *ngIf="appConfig.isGuestLoginEnabled">
            <button class="btnLogin" mat-flat-button color="primary" *ngIf="!isChangePassword"
                (click)="enableGuestLogin()">Login with SSO</button>
            <button *ngIf="data.isAccessTokenExpired" class="btnLogin cancelLogin" mat-flat-button color="primary"
                (click)="logout()">Cancel</button>
        </div>
    </div>

    <div *ngIf="appConfig.showAppVersion && commonService.ProjectLSData.appVersion && !this.data.isAccessTokenExpired && !this.data.location" class="appVersion">
        v{{commonService.ProjectLSData.appVersion}}
    </div>

    <div *ngIf="showLicenseAlert && this.data.location === 'login'" class="licenseInfoBanner loginCredentialFields loginEmailId zoomLevelMatFormfield" [ngClass]="licenseSeverityClass">
        <mat-icon  class="licenseStatusIcon" svgIcon="warningFilledIcon"></mat-icon>
        <div class="licenseInfoText" *ngIf="licenseDueDays > 0; else expiredLicense">
            License due in <span class="licenseDays">{{licenseDueDays}}</span> day{{licenseDueDays === 1 ? '' : 's'}}
        </div>
        <ng-template #expiredLicense>
            <div class="licenseInfoText licenseDays">
                License expired!
            </div>
        </ng-template>

        <button  *ngIf="!renewLicense" mat-stroked-button type="button" class="licenseActionBtn" [ngClass]="licenseSeverityClass"
            (click)="showLicenseDetails()">
            Renew
        </button>
    </div>

</div>
